import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';
import { SearchResult } from 'src/app/shared/models/search-result.model';

@Component({
  selector: 'app-practitioner-list',
  templateUrl: './practitioner-list.component.html',
  styleUrls: ['./practitioner-list.component.scss']
})
export class PractitionerListComponent implements OnInit, OnDestroy {
  @Input() results: SearchResult[];
  @Input() resultsLoaded: boolean;
  @Input() selectedPractitioner: string;

  constructor(private practitionerService: PractitionerService) { }

  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

}
